"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableMask = void 0;
const tslib_1 = require("tslib");
const fast_xml_parser_1 = require("fast-xml-parser");
const mobx_1 = require("mobx");
const drawable_1 = require("./drawable");
const parser = new fast_xml_parser_1.XMLParser({
    attributeNamePrefix: '',
    ignoreAttributes: false,
    parseAttributeValue: true,
    trimValues: true,
    // all groups should be parsed as arrays even if there is only one child
    isArray: (name) => {
        if (name === 'g') {
            return true;
        }
        return false;
    },
});
class CollectionModelDrawableMask extends drawable_1.CollectionModelDrawable {
    constructor(collectionModelDrawableState, drawableId, pukekoLocation) {
        super(collectionModelDrawableState, drawableId);
        /**
         * @deprecated Write an async method to get this if it hasn't already been fetched, then return the value
         */
        this.parsedSvg = null;
        this.svgStringInFlight = false;
        this.pukekoLocation = Object.assign({}, pukekoLocation);
    }
    get isInsightMeasurement() {
        return true;
    }
    isApprovableInsightDrawable() {
        return false;
    }
    get isVisible() {
        return true;
    }
    get x() {
        var _a, _b;
        return ((_b = (_a = this.drawableState.capture) === null || _a === void 0 ? void 0 : _a.resolution.width) !== null && _b !== void 0 ? _b : 0) / 2;
    }
    get y() {
        var _a, _b;
        return ((_b = (_a = this.drawableState.capture) === null || _a === void 0 ? void 0 : _a.resolution.height) !== null && _b !== void 0 ? _b : 0) / 2;
    }
    fetchSvgMask(fetchingCallBack) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // If the string already exists or is in flight, don't fetch it again
            if (this.parsedSvg) {
                return;
            }
            if (this.svgStringInFlight) {
                return;
            }
            this.svgStringInFlight = true;
            const svgString = yield fetchingCallBack();
            this.parsedSvg = parser.parse(svgString);
            this.svgStringInFlight = false;
        });
    }
    /**
     * Check if the mask SVG has been loaded AND has visible detections.
     *
     * @returns The visible SVG detection groups, otherwise null.
     */
    getVisibleSvgDetectionGroups(enabledDetectionGroups, log) {
        var _a;
        if (!this.parsedSvg) {
            log === null || log === void 0 ? void 0 : log.warn({ drawable: this.id }, 'getVisibleSvgDetectionGroups: SVG has not been loaded');
            return null;
        }
        if (!this.parsedSvg.svg) {
            log === null || log === void 0 ? void 0 : log.warn({ drawable: this.id }, 'getVisibleSvgDetectionGroups: Root of SVG is missing <svg> tag');
            return null;
        }
        if (!((_a = this.parsedSvg.svg.g) === null || _a === void 0 ? void 0 : _a.length)) {
            log === null || log === void 0 ? void 0 : log.warn({ drawable: this.id }, 'getVisibleSvgDetectionGroups: SVG contains no detection groups');
            return null;
        }
        // Check if any of the SVG detection groups are present in enabledDetectionGroups.
        if (!this.parsedSvg.svg.g.some((g) => enabledDetectionGroups.includes(g.id))) {
            log === null || log === void 0 ? void 0 : log.warn({
                drawable: this.id,
                enabledDetectionGroups,
                maskDetectionGroups: this.parsedSvg.svg.g.map((g) => g.id),
            }, 'getVisibleSvgDetectionGroups: None of the detection groups in the SVG were listed in enabledDetectionGroups');
            return null;
        }
        // Mask contains at least one visible detection group, which means the user can see it.
        return this.parsedSvg.svg.g;
    }
    static isMask(t) {
        return t instanceof CollectionModelDrawableMask;
    }
    clone(newParentDrawableState) {
        return new CollectionModelDrawableMask(newParentDrawableState, this.id, this.pukekoLocation);
    }
    equals(other) {
        return (other instanceof CollectionModelDrawableMask &&
            this.pukekoLocation.product_version_number === other.pukekoLocation.product_version_number &&
            this.pukekoLocation.resource_path === other.pukekoLocation.resource_path &&
            this._equals(other));
    }
}
exports.CollectionModelDrawableMask = CollectionModelDrawableMask;
tslib_1.__decorate([
    mobx_1.observable
], CollectionModelDrawableMask.prototype, "parsedSvg", void 0);
//# sourceMappingURL=mask.drawable.js.map